import {
  AdditionalItemType,
  ProductAdditional,
  ProductAdditionalGroupRequest,
  ProductAdditionalGroupResponse,
  ProductAdditionalItem,
  ProductAdditionalItemRequest,
  ProductAdditionalItemResponse,
} from "@/interfaces/products";
import { BaseService } from "./BaseService";

export class ProductAdditionalsService extends BaseService<
  ProductAdditionalGroupRequest,
  ProductAdditionalGroupResponse
> {
  constructor(productId: string) {
    super();
    this.path = `products/${productId}/additionals`;
  }

  async list(): Promise<ProductAdditional[]> {
    const response = await this.findAll();
    const groups = response.data ?? [];

    return groups.map((group) => ({
      id: group.id,
      name: group.name,
      selectionType: group.selectionType,
      minQuantity: group.minQuantity,
      maxQuantity: group.maxQuantity,
      items: (group.items ?? []).map((item) => this.mapItemResponse(item)),
    }));
  }

  private mapItemResponse(
    item: ProductAdditionalItemResponse,
  ): ProductAdditionalItem {
    return {
      id: item.id,
      name: item.label,
      unitPrice: item.unitPrice,
      unitCost: item.unitCost,
      productId: item.productId ?? undefined,
      fileId: item.fileId ?? undefined,
      type: item.productId ? AdditionalItemType.PRODUCT : AdditionalItemType.CUSTOM,
      consumptionFactor: item.consumptionFactor,
    };
  }

  async createItem(
    additionalId: string,
    data: ProductAdditionalItemRequest
  ): Promise<ProductAdditionalItemResponse> {
    return (await this.request(`${this.path}/${additionalId}/items`, {
      method: "POST",
      body: JSON.stringify(data),
    })) as ProductAdditionalItemResponse;
  }

  async updateItem(
    additionalId: string,
    itemId: string,
    data: ProductAdditionalItemRequest
  ): Promise<ProductAdditionalItemResponse> {
    return (await this.request(
      `${this.path}/${additionalId}/items/${itemId}`,
      {
        method: "PUT",
        body: JSON.stringify(data),
      }
    )) as ProductAdditionalItemResponse;
  }

  async deleteItem(additionalId: string, itemId: string): Promise<void> {
    await this.request(`${this.path}/${additionalId}/items/${itemId}`, {
      method: "DELETE",
    });
  }
}
